import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import {LoadingService} from "od-component-library";
import {ToasterService} from "_@shared/services/toaster.service";

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptor {
  constructor(
    private toasterService: ToasterService,
    private loadingService: LoadingService
  ) {
  }
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingService.showLoader(true);
    
    return next.handle(request).pipe(
      catchError(this.handleError.bind(this)),
      finalize(() => {
        if (!request.urlWithParams.includes('?auto=true')) {
          this.loadingService.showLoader(false); // Hide the loader
        }
      })
    );
  }
  
  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status !== 200) {
      let errorMessage = 'An error has occurred';
      if (error.error && error.error.error) {
        errorMessage += `: ${error.error.error}`;
      }
      this.toasterService.showError(errorMessage, 5000);
    }
    
    return throwError(() => error);
  }
}
